<template>
  <div>
    <div class="Examin_view">
      <div class="examin_mian">
        <div class="examin_head">
          <el-form
            :label-position="labelPosition"
            label-width="90px"
            :model="formLabelAlign"
            ref="formLabelAlign"
          >
            <el-form-item label="考试名称：" prop="name">
              <el-input
                v-model.trim="formLabelAlign.name"
                placeholder="请输入考试名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="组卷人：" prop="account">
              <el-input
                v-model.trim="formLabelAlign.account"
                placeholder="请输入组卷人"
              ></el-input>
            </el-form-item>
            <el-form-item label="组卷时间：" prop="value3">
              <el-date-picker
                v-model="examTime"
                @change="searchChang"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                :default-time="['00:00:00', '23:59:59']"
              >
              </el-date-picker>
            </el-form-item>
          </el-form>
          <div class="query_btn">
            <el-button
              type="primary"
              icon="el-icon-search"
              class="searchbtn"
              @click="searchBtn"
              >搜索</el-button
            >
            <el-button
              icon="el-icon-refresh"
              class="searchbtn sonbtn"
              @click="resetForm('formLabelAlign')"
              >重置</el-button
            >
          </div>
        </div>
        <div class="opratingbtn">
          <el-button
            size="small"
            @click="handleClick('kong')"
            v-if="$root.$hasbtn('添加试卷')"
          >
            <i class="iconfont icon-action-add-hover"></i>添加试卷
          </el-button>
          <el-button @click="reqdeleteArr" v-if="$root.$hasbtn('批量删除试卷')">
            <i class="iconfont icon-batch-shanchu"></i>批量删除试卷
          </el-button>
        </div>
        <!-- 表格 -->
        <div class="examinee_form" v-loading="loading">
          <el-table
            ref="tabledata"
            :data="getData"
            style="width: 100%"
            :row-class-name="tableRowClassName"
            @selection-change="handleSelectionChange"
            :row-key="getRowKeyOfTarget"
            @row-click="StepsListRowClick"
            :header-cell-style="{
              'background-color': '#8FCBFF',
              color: '#333333',
              height: '60px',
            }"
          >
            <el-table-column
              type="selection"
              width="80"
              :reserve-selection="true"
            ></el-table-column>
            <el-table-column label="序号" width="80">
              <template slot-scope="scope">
                {{ scope.$index + 1 + (currentPage3 - 1) * pageSize }}
              </template>
            </el-table-column>
            <el-table-column
              v-for="(item, index) in formColumns"
              :key="index"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              height="150"
              label-height="50"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="address"
              label="操作"
              align="center"
              width="220"
            >
              <template slot-scope="scope">
                <div class="operation_box">
                  <el-button
                    @click.stop="handleClick(scope.row)"
                    type="text"
                    size="small"
                    v-if="$root.$hasbtn('编辑')"
                    >编辑</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    v-if="$root.$hasbtn('导出')"
                    @click.stop="opendowmtest(scope.row)"
                    >导出</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    v-if="$root.$hasbtn('复制')"
                    @click.stop="copy(scope.row, scope.$index)"
                    >复制</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    v-if="$root.$hasbtn('删除')"
                    @click.stop="examDelete(scope.row, scope.$index)"
                    >删除</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- 分页 -->
      <div class="foot_box">
        <div class="foot_pagetions">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="showpageindex"
            :page-size="pageSize"
            :page-sizes="pagesizesarr"
            layout="prev, pager, next,sizes, jumper"
            :total="total"
            class="pagination"
          >
          </el-pagination>
        </div>
      </div>
      <!-- 下载弹窗 -->
      <div class="everywhere">
        <el-dialog
          title="导出试卷"
          :visible.sync="dialogVisible"
          width="30%"
          :close-on-click-modal="false"
        >
          <p>确定导出{{ isselecttest.ExamName }} 试卷吗？</p>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" :loading="paperloading" @click="dowmtest">
              确 定
            </el-button>
          </span>
        </el-dialog>
      </div>
      <!-- 弹窗 -->
      <Popup ref="popup" :statePopupstatus="statePopupstatus" />
    </div>
  </div>
</template>
<script>
import systemclass from "@/api/systemclassification";
import resourcereq from "@/api/resources";
import qs from "qs";
import { BASEUrl } from "@/utils/request";
import Popup from "@/views/theonlineTest/published/components/Popup.vue";
import { getexamList, examDelete, examDeleteArr } from "@/api/index.js";
import loginvuex from "@/store/index";
import getappstyle from "@/api/questionbank";
export default {
  data() {
    return {
      stateArr: [], //存储开始时间和结束时间。
      paperloading: false, //试卷延迟
      value1: "", //时间
      dialogVisible: false, //导出试卷
      isselecttest: "", //当前选择的试卷的详情信息
      videodialogVisible: {
        isshow: false,
        videourl: "",
        videoname: "",
        examBeginDate: "", //时间
        examEndDate: "", // 结束时间
      },
      statePopupstatus: {}, //当前选中行的信息。
      dialogVisibleObj: {
        addExamineeShow: true, // 添加考生
      },
      labelPosition: "right",
      deleteStabe: false, // 删除警告弹窗
      deleteFang: 0, // 是否批量弹窗验证
      examTime: "", // 考试时间
      formLabelAlign: {
        name: "", //名称
        account: "", //组卷人
        examBeginDate: "", //时间
        examEndDate: "", // 结束时间
      },
      getDataCondition: {
        name: "", //名称
        account: "", //组卷人
      },
      row: {}, // 当前行
      formExamin: {
        name: "",
      },
      showpageindex: 1, //显示的索引盒子
      getData: [],
      formColumns: [
        {
          prop: "ExamName",
          label: "考试名称",
          // width: "90px",
        },
        {
          prop: "BeginTime1",
          label: "组卷时间",
          // width: "90px",
        },
        {
          prop: "UserName",
          label: "组卷人",
          // width: "90px",
        },
      ],
      currentPage3: 1, //  当前页数
      pageSize: 10,
      total: 100,
      pagesizesarr: [5, 10, 20, 50, 100],
      loading: true,
      countFile: "", //总容量
      multipleSelection: [], // 选中数据
      multipleSelectionIds: [],
      multipleSelectionCount: 0,
      FileStream: "",
    };
  },
  components: {
    Popup,
  },
  methods: {
    // 搜索
    searchBtn() {
      this.Buriedpoint(
        {
          code: "PaperTest:Paperlist:search",
          parent_code: "PaperTest:Paperlist",
        },
        "statetime"
      );
      this.currentPage3 = 1;
      if (this.formLabelAlign.name) {
        this.getDataCondition.name = this.formLabelAlign.name;
      } else {
        this.getDataCondition.name = "";
      }
      if (this.formLabelAlign.account) {
        this.getDataCondition.account = this.formLabelAlign.account;
      } else {
        this.getDataCondition.account = "";
      }
      this.getlist();
    },
    // 勾选当前行激活check
    StepsListRowClick(row, column, event) {
      this.$refs.tabledata.toggleRowSelection(row);
    },
    // chang搜索
    searchChang() {
      this.loading = true;
      if (this.examTime == null) {
        this.formLabelAlign.examBeginDate = "";
        this.formLabelAlign.examEndDate = "";
      }
      this.getlist();
    },
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    // 复制功能
    copy(row, index) {
      this.Buriedpoint(
        {
          code: "PaperTest:Paperlist:copy",
          parent_code: "PaperTest:Paperlist",
        },
        "statetime"
      );
      this.statePopupstatus = row;
      console.log(row);
      if (row.PaperModeName === "随机命题") {
        this.$refs.popup.dialogVisibleObj.randomCopy = true;
      } else {
        this.$refs.popup.dialogVisibleObj.copyVisible = true;
      }
    },
    // 删除
    examDelete(row, index) {
      this.Buriedpoint(
        {
          code: "PaperTest:Paperlist:delete",
          parent_code: "PaperTest:Paperlist",
        },
        "statetime"
      );
      this.statePopupstatus = row;
      this.$refs.popup.dialogVisibleObj.IsdeleteVisible = true;
    },
    resetForm(formLabelAlign) {
      this.Buriedpoint(
        {
          code: "PaperTest:Paperlist:rest",
          parent_code: "PaperTest:Paperlist",
        },
        "statetime"
      );
      // 重置
      this.$refs[formLabelAlign].resetFields();
      this.currentPage3 = 1;
      this.showpageindex = 1;
      this.loading = true;
      this.getDataCondition.name = "";
      this.getDataCondition.account = "";
      this.examTime = "";
      this.formLabelAlign.examBeginDate = "";
      this.formLabelAlign.examEndDate = "";
      this.getlist();
    },
    // 查询
    searchList() {
      this.currentPage3 = 1;
      this.getlist();
    },
    isNotSet() {
      if (this.getData.length != 0) {
        this.getData.map((item) => {
          console.log(item, "时间");
          for (let ztiem in item) {
            if (
              item[ztiem] === "" ||
              item[ztiem] === null ||
              item[ztiem] == "Invalid date-Invalid date"
            ) {
              item[ztiem] = "未设置";
            }
          }
        });
      }
    }, // 初始字段为空时状态
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.loading = true;
      this.getlist(); // 重新发起请求
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage3 = val;
      this.loading = true;
      this.getlist(); // 重新发起请求
    },
    // 给每一行设置key
    getRowKeyOfTarget(row) {
      return row.ExamID;
    },
    handleSelectionChange(val) {
      this.multipleSelectionIds = [];
      this.multipleSelection = [];
      this.multipleSelectionCount = 0;
      this.multipleSelection = val; // 批量删除多选状态
      val.forEach((v) => {
        this.multipleSelectionIds.push(v.ExamID);
      });
      this.multipleSelectionCount = this.multipleSelection.length;
      console.log(this.multipleSelectionIds, "<<=====multipleSelectionIds");
    },
    async towebpdf(item) {
      this.videodialogVisible.isshow = true;
      let parma = {
        name: `tibosi/${JSON.parse(localStorage.getItem("userlist")).hid}/${
          item.VideoName
        }.mp4`,
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        hid: JSON.parse(localStorage.getItem("userlist")).hid,
      };
      let resurl = await resourcereq.getVideoURL(parma);
      this.videodialogVisible.videourl = resurl.data.Data.url;
      this.videodialogVisible.videoname = resurl.data.Data.name;
      let player = document.querySelector("#myVideo");
      player.src = resurl.data.Data.url;
    },
    handleClick(videoinfo) {
      this.statePopupstatus = videoinfo;
      if (videoinfo == "kong") {
        //进入新增试卷模式，。
        // this.$parent.videoinfo = "kong";
        localStorage.setItem("isreload", true);
        this.Buriedpoint({
          code: "PaperTest:Paperlist:add",
          parent_code: "PaperTest:Paperlist",
        });
        this.$parent.cutcoms(1);
      } else {
        localStorage.setItem("isreload", true);
        this.Buriedpoint({
          code: "PaperTest:Paperlist:edit",
          parent_code: "PaperTest:Paperlist",
        });
        this.$parent.videoinfo = videoinfo;
        this.$parent.cutcoms(2);
      }
    },
    // 单个删除
    deletelist(row) {
      this.deleteFang = 0;
      this.row = row;
      this.deleteStabe = true;
    },
    async reqdelete(items) {
      console.log(items);
      let parmas = {
        VideoID: this.row.VideoID,
        filename: `${this.row.VideoName}.${this.row.Format}`,
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        hid: JSON.parse(localStorage.getItem("userlist")).hid,
        _examID: "",
      };
      console.log(parmas);
      let res = await resourcereq.deleteVideo(parmas);
      if (res.data.Status === 200) {
        this.deleteStabe = false;
        this.$message({
          message: "恭喜你，删除成功",
          type: "success",
        });
        this.getlist();
      }
    },
    //打开导出试卷的确认窗口
    async opendowmtest(item) {
      this.Buriedpoint(
        {
          code: "PaperTest:Paperlist:export",
          parent_code: "PaperTest:Paperlist",
        },
        "statetime"
      );
      console.log(item);
      this.isselecttest = item;
      //  this.dialogVisible = true;
      //请求远程服务器下载文件
      let parmas = {
        hid: JSON.parse(loginvuex.state.userlist).hid,
        examID: item.ExamID,
        isAnswer: 0,
        userID: JSON.parse(loginvuex.state.userlist).userID,
      };
      let res = await getappstyle.getNewAspx(qs.stringify(parmas));
      if (res.status == "200") {
        this.dialogVisible = true;
        this.FileStream = res.data;
      } else {
        this.$message.error(res.statusText);
      }
      console.log(res);
    },
    //导出试卷功能
    dowmtest() {
      this.paperloading = true;
      setTimeout(() => {
        const blob = new Blob([this.FileStream]);
        let link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", `${this.isselecttest.ExamName}.zip`);
        link.click();
        link = null;
        this.dialogVisible = false;
        this.paperloading = false;
      }, 2000);
    },
    // 批量删除
    reqdeleteArr() {
      this.Buriedpoint(
        {
          code: "PaperTest:Paperlist:batchDelete",
          parent_code: "PaperTest:Paperlist",
        },
        "statetime"
      );
      const ids = this.multipleSelectionIds;
      if (ids.length <= 0) {
        this.$message({
          message: "请选择需要删除的试卷",
          type: "warning",
        });
      }
      console.log(this.multipleSelection.HospitalID);
      if (ids.length <= 0) return;
      this.$confirm("此操作将批量删除该账户, 是否继续?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          // 发送请求
          let params = {
            examIDArr: `[${ids}]`,
            guid: JSON.parse(loginvuex.state.userlist).guid,
            userID: JSON.parse(loginvuex.state.userlist).userID,
            hid: this.multipleSelection.HospitalID,
          };
          const Data = await examDeleteArr(params);
          if (Data.status === 200) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.currentPage3 = 1;
            this.getlist(); // 重新发起请求
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    deletelistArr() {
      let parmas = {
        VideoID: `[${this.multipleSelectionIds}]`,
        // filename: `${items.VideoName}.${items.Format}`,
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        hid: JSON.parse(localStorage.getItem("userlist")).hid,
        _examID: "",
      };
      const row = resourcereq.deleteVideoArr(parmas);
      this.deleteStabe = false;
      this.$message({
        message: "恭喜你，删除成功",
        type: "success",
      });
      this.getlist();
      console.log(row);
    },
    async getlist() {
      if (this.examTime) {
        const time = JSON.parse(JSON.stringify(this.examTime));
        this.formLabelAlign.examBeginDate = this.$moment(time[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.formLabelAlign.examEndDate = this.$moment(time[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      //获取列表信息
      let params = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        operatUserID: "",
        type: 2,
        pageIndex: this.currentPage3 - 1,
        isPostV: "true",
        eachPageNum: 10,
        eachPageNum: this.pageSize, //当前也多少条数。
        examName: this.getDataCondition.name, // 考试名称
        operatUserName: this.getDataCondition.account, // 组卷模式 account
        examModel: "",
        examStatus: "", // 考试状态
        createBeginTime: this.formLabelAlign.examBeginDate, //考试开始时间
        createEndTime: this.formLabelAlign.examEndDate, //考试结束时间
      };
      let res = await getexamList(params);
      this.isNotSet();
      console.log(res);
      setTimeout(() => {
        this.loading = false;
      }, 500);
      this.getData = res.data.Data.data;
      if (this.getData) {
        this.getData.map((item) => {
          // 时间拼接
          item.BeginTime1 = this.$moment(item.CreateTime).format(
            "YYYY/MM/DD HH:mm"
          );
        });
      }
      this.total = res.data.Data.count;
      //this.countFile = res.data.Data.result[1];
      // this.total = res.data.Data.pageCount;
      // console.log(this.total, "我玩的的1");
      //请求数据接口  .然后覆盖给原始页面  9.1
    },
    capacity(item) {
      return () => {
        if (item != "") {
          console.log(item[0].countFile);
          return (item[0].countFile / 1024 / 1024).toFixed(1) + "M/1024M";
        }
      };
    },
    Buriedpoint(itemt, isstate) {
      if (isstate == "statetime") {
        //次数
        let parmas = {
          type: "2",
          code: itemt.code,
          parent_code: itemt.parent_code,
          stay_start_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_end_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_time: 1,
          ation_source: null,
          source: "khy",
          ip: null,
          userID: JSON.parse(loginvuex.state.userlist).userID,
          guid: JSON.parse(loginvuex.state.userlist).guid,
        };
        systemclass.addburied(parmas);
      } else {
        //闭环时间
        if (this.stateArr.length == 0) {
          this.stateArr[0] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
        } else {
          this.stateArr[1] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
          let statetime = this.$moment(new Date(this.stateArr[1])).diff(
            new Date(this.stateArr[0]),
            "seconds"
          );
          let parmas = {
            type: "2",
            code: itemt.code,
            parent_code: itemt.parent_code,
            stay_start_time: this.stateArr[0],
            stay_end_time: this.stateArr[1],
            stay_time: statetime,
            ation_source: null,
            source: "khy",
            ip: null,
            userID: JSON.parse(loginvuex.state.userlist).userID,
            guid: JSON.parse(loginvuex.state.userlist).guid,
          };
          systemclass.addburied(parmas);
          this.stateArr = [];
        }
      }
    },
  },
  computed: {
    opentime() {
      return function (bigintime, endtime) {
        if (bigintime == null && endtime == null) {
          console.log(111);
          let text = "未设置";
          return text;
        } else {
          bigintime = this.$moment(bigintime).format("YYYY/MM/DD HH:mm");
          endtime = this.$moment(endtime).format("YYYY/MM/DD HH:mm");
          let Time = bigintime + "-" + endtime;
          return Time;
        }
      };
    },
    filesize() {
      return function (Format, size) {
        size = (size / (1024 * 1024)).toFixed(1);
        return Format + "/" + size + "M";
      };
    },
    PercentageOfCapacity() {
      if (this.countFile != "") {
        return (
          (this.countFile[0].countFile / 1024 / 1024 / 1024).toFixed(2) * 100
        );
      }
      return 0;
    },
  },
  activated() {
    this.getlist();
    this.isNotSet();
  },
  created() {
    this.stateArr = [];
    localStorage.removeItem("isreload");
  },
};
</script>

<style lang="scss" scoped>
.Examin_view {
  box-sizing: border-box;
  background-color: #ffffff;
  width: 100%;
  height: 100%;
  .title_box {
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  .examin_mian {
    box-sizing: border-box;
    background-color: #ffffff;
    width: 100%;
    height: 100%;
  }
  ::v-deep .dialog-footer {
    margin-bottom: 30px;
  }
  ::v-deep.el-dialog__footer {
    justify-content: center !important;
  }
  .el-dialog__footer span > button {
    margin-top: 10px;
    width: 103px;
    height: 42px;
  }
  ::v-deep .el-dialog {
    width: 1593px;
    border-radius: 5px 5px 0px 0px;
  }
  ::v-deep .el-dialog__header {
    padding: 0px 24px;
  }
  .examin_head {
    padding: 30px 24px 10px 30px;
    display: flex;
    border-bottom: 1px solid rgba(231, 231, 231, 0.774);
    .el-form {
      display: flex;
    }
    .query_btn {
      display: flex;
      .el-button {
        width: 88px;
        height: 40px;
        margin-left: 24px;
      }
    }
  }
  .examinee_form {
    min-height: 480px;
    padding: 0px 20px 0px 34px;
  }
}

::v-deep .delete_view .el-dialog {
  width: 320px;
  height: 260px;
  border-radius: 5px 5px 0px 0px;
  .input_layout {
    display: flex;
  }
  .el-dialog__body {
    padding: 24px 24px;
  }
  .mian {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
    p {
      font-size: 16px;
    }
  }
  .dialog-footer {
    .el-button {
      width: 70px;
      height: 40px;
    }
  }
}
::v-deep .el-dialog__header {
  height: 55px;
  line-height: 55px;
  background: linear-gradient(180deg, #64b5ff 0%, rgba(199, 228, 255, 1) 100%);
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}
::v-deep .el-dialog__footer {
  padding: 0;
  display: flex;
  justify-content: center;
  align-content: center;
  text-align: center;
  span > button {
    width: 60px;
    height: 32px;
    opacity: 1;
    border-radius: 4px;
    padding: 0px;
    margin-top: 38px;
    &:nth-child(2) {
      margin-left: 90px;
    }
  }
}
::v-deep .el-dialog__body {
  padding: 0;
}
::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
// 分页
.foot_box {
  position: relative;
  height: 88px;
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #409eff;
        border: none;
      }
    }
  }
}
.operation_box {
  .el-button {
    font-size: 16px;
  }
}
.opratingbtn {
  height: 70px;
  padding-left: 30px;
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  ::v-deep .el-button {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    letter-spacing: 1px;
    span > i {
      font-size: 14px !important;
      margin-right: 5px;
    }
  }
  > :nth-child(1) {
    height: 40px;
    background-color: #64b5ff;
    color: #ffffff;
    border: #ffffff;
    margin-right: 16px;
  }
  > :nth-child(2) {
    height: 40px;
    background-color: #e54d4d;
    color: #ffffff;
    border: #ffffff;
  }
}
.videocontent {
  background: #222222;
}

.videoname {
  text-align: center;
  font-size: 17px;
  font-family: "微软雅黑";
  color: #ffffff;
}
::v-deep .el-progress {
  width: 400px;
  margin-left: 900px;
}
::v-deep.el-table th > .cell {
  text-align: center;
}
::v-deep .el-table-column--selection .cell {
  text-align: center;
}
::v-deep .el-table th:nth-child(1) {
  opacity: 1;
  border-radius: 4px 0px 0px 4px;
}
::v-deep .el-table th:nth-child(9) {
  opacity: 1;
  border-radius: 0px 4px 4px 0px;
}

::v-deep .el-form {
  div:nth-child(2),
  div:nth-child(3) {
    .el-form-item__label {
      width: 120px !important;
    }
    .el-form-item__content {
      margin-left: 120px !important;
    }
  }
}
::v-deep .el-table .cell {
  text-align: center;
}
.everywhere {
  ::v-deep .el-dialog {
    width: 441px !important;
    border-radius: 5px 5px 0px 0px;
  }
  .el-dialog__header {
    height: 55px;
    opacity: 1;
    border-radius: 5px 5px 0px 0px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    ) !important;
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    button:nth-child(1) {
      margin-right: 50px;
    }
  }
  p {
    padding: 24px;
  }
}
</style>
